import { Contact } from "lucide-react";
import { BUSINESS_CARDS } from "@/data/businessCards";
import { BusinessCard } from "@/components/BusinessCard";

export default function Visitenkarten() {
  return (
    <div className="max-w-5xl mx-auto" data-testid="visitenkarten-page">
      <div className="flex items-center gap-3 mb-2">
        <span className="flex items-center justify-center rounded-xl" style={{ width: 44, height: 44, background: "#FFF4E3", color: "#F39200" }}>
          <Contact className="w-6 h-6" />
        </span>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold" style={{ color: "#0B1F3A", fontFamily: "'Space Grotesk', sans-serif" }}>
            Digitale Visitenkarten
          </h1>
          <p className="text-sm text-muted-foreground">
            Teilbar per Link &amp; QR-Code · „Kontakt speichern" (vCard) · Download als Bild
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 justify-items-center mt-8">
        {BUSINESS_CARDS.map((person) => (
          <BusinessCard key={person.slug} person={person} />
        ))}
      </div>
    </div>
  );
}
